export enum ESmsLogStatuses {
  /**
   * The SMS is not delivered yet, SMS provider is actively trying to deliver it
   * @type {SmsLogStatusEnum.SENDING}
   */
  'SENDING' = 'SENDING',
  /**
   * SMS Successfully delivered. It does not guarantee that the patient has read it
   * @type {SmsLogStatusEnum.DELIVERED}
   */
  'DELIVERED' = 'DELIVERED',
  /**
   * Patient read the message.
   * @type {SmsLogStatusEnum.READ}
   */
  'READ' = 'READ',
  /**
   * An error was raised by the provider or the carrier, probably happened during
   * the delivery attempt. Can be "definitive" or "temporary"
   *
   * Example of temporary errors: patient's phone is off, patient has no network connectivity, etc...
   * Example of definitive errors: phone is invalid, patient's contract with carrier has ended etc...
   * @type {SmsLogStatusEnum.PROVIDER_ERROR}
   */
  'PROVIDER_ERROR' = 'PROVIDER_ERROR',
  /**
   * An error happened before the SMS was submitted to the carrier. Can be a
   * connectivity error with the provider's API
   * @type {SmsLogStatusEnum.ERROR}
   */
  'ERROR' = 'ERROR',
  /**
   * Curecall refused to send the SMS because the patient has not given consent
   * @type {SmsLogStatusEnum.BLOCKED_NO_CONSENT}
   */
  'BLOCKED_NO_CONSENT' = 'BLOCKED_NO_CONSENT',
  /**
   * Curecall refused to send the SMS because the patient was archived at this time
   * @type {SmsLogStatusEnum.BLOCKED_ARCHIVED}
   */
  'BLOCKED_ARCHIVED' = 'BLOCKED_ARCHIVED',
  /**
   * Curecall refused to send the SMS because the patient's phone number was not
   * whitelisted. This can only happen in environments using a whitelist.
   * @type {SmsLogStatusEnum.BLOCKED_WHITELIST}
   */
  'BLOCKED_WHITELIST' = 'BLOCKED_WHITELIST',
  /**
   * Curecall refused to send the SMS because the patient's phone number was
   * invalid.
   * @type {SmsLogStatusEnum.BLOCKED_INVALID_PHONE}
   */
  'BLOCKED_INVALID_PHONE' = 'BLOCKED_INVALID_PHONE',
  /**
   * Curecall tried to send a message to the patient on a channel not compatible
   * with patient's phone (e.g. RCS: The patient has not enabled RCS. WhatsApp:
   * the patient has not installed WhatsApp)
   * @type {SmsLogStatusEnum.UNSUPPORTED_CHANNEL}
   */
  'UNSUPPORTED_CHANNEL' = 'UNSUPPORTED_CHANNEL',
  /**
   * Curecall refused to send the SMS because no communication channel is available for this patient.
   * @type {SmsLogStatusEnum.BLOCKED_NO_COMMUNICATION_CHANNEL}
   */
  'BLOCKED_NO_COMMUNICATION_CHANNEL' = 'BLOCKED_NO_COMMUNICATION_CHANNEL',
}

export enum ESmsLogSource {
  WORKFLOW = 'WORKFLOW',
  USER = 'USER',
  OTP = 'OTP',
  COPILOT = 'COPILOT',
  BACKEND = 'BACKEND',
  CHATBOT = 'CHATBOT',
  PATIENT_APP = 'PATIENT_APP',
}

export type TSmsLogType = 'TEXT' | 'IMAGE' | 'BUTTON_CLICK' | 'DOCUMENT' | 'INVALID_FILE' | 'UNEXPECTED_FILE'

export type TSmsLog = {
  id: number
  message: string
  status: ESmsLogStatuses
  source: ESmsLogSource | null
  inbound: boolean
  sentAt: string
  deliveredAt?: string
  SentByConversationId?: number
  SentByWorkflowId?: number
  workflowIntlLabel?: Record<string, string> | null
  conversationLabel?: string | null
  type: TSmsLogType
}
